module.exports = __webpack_public_path__ + "static/media/FR.02bfcd79.png";